// extracted by mini-css-extract-plugin
module.exports = {"emptyDataNotice":"NoResultsMessage_emptyDataNotice__zv_h8","heading":"NoResultsMessage_heading__0UgPS"};